import countries from './countries.json'
import { ICountry } from './models/country'

// The countries offered in the phone prefix picker: the same ones as the app. countries.json keeps
// the full list for lookups (e.g. working out the country of a number that's already saved).
const PHONE_COUNTRY_CODES = [
  'AD', 'AT', 'BE', 'CA', 'HR', 'CZ', 'DK', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT',
  'LU', 'MT', 'MC', 'NO', 'PL', 'PT', 'SI', 'ES', 'CH', 'GB', 'US'
]

export const phoneCountries: ICountry[] = countries.filter(country => PHONE_COUNTRY_CODES.includes(country.code))
